export default __webpack_public_path__ + "static/media/e2-phone.a0ea5afe.png";